export default "/images/vendor/flag-icons/flags/1x1/sh.svg?281c8c4528284574f7e52cde1ac167d2";